import { User, OOORequest } from '../types'

export const MOCK_USERS: User[] = [
  {
    id: 'u8',
    name: 'Alex Admin',
    role: 'Admin',
  },
  {
    id: 'u1',
    name: 'Sarah Reed',
    role: 'Processing Manager',
    ptoTotal: 25,
    ptoUsed: 5,
  },
  {
    id: 'u7',
    name: 'David Cole',
    role: 'Loan Officer Manager',
    ptoTotal: 25,
    ptoUsed: 10,
  },
  {
    id: 'u2',
    name: 'Mike Processor',
    role: 'Processor',
    activeLoans: 12,
    ptoTotal: 20,
    ptoUsed: 15,
  },
  {
    id: 'u3',
    name: 'Lisa Processor',
    role: 'Processor',
    activeLoans: 8,
    ptoTotal: 20,
    ptoUsed: 4,
  },
  {
    id: 'u6',
    name: 'Tom Processor',
    role: 'Processor',
    activeLoans: 15,
    ptoTotal: 20,
    ptoUsed: 19,
  },
  {
    id: 'u4',
    name: 'John Officer',
    role: 'Loan Officer',
    pipelineSize: 5,
  },
  {
    id: 'u5',
    name: 'Emma Officer',
    role: 'Loan Officer',
    pipelineSize: 9,
  },
]

export const MOCK_REQUESTS: OOORequest[] = [
  {
    id: 'r1',
    userId: 'u2',
    userName: 'Mike Processor',
    userRole: 'Processor',
    startDate: '2026-06-15T09:00',
    endDate: '2026-06-20T17:00',
    message: 'Family vacation',
    status: 'Pending',
  },
  {
    id: 'r2',
    userId: 'u4',
    userName: 'John Officer',
    userRole: 'Loan Officer',
    startDate: '2026-07-01T09:00',
    endDate: '2026-07-05T17:00',
    message: 'Attending industry conference',
    status: 'Pending',
  },
  {
    id: 'r3',
    userId: 'u3',
    userName: 'Lisa Processor',
    userRole: 'Processor',
    startDate: '2026-05-10T08:00',
    endDate: '2026-05-12T17:00',
    message: 'Medical appointment and recovery',
    status: 'Approved',
    coverageIds: ['u2', 'u6'],
  },
  {
    id: 'r4',
    userId: 'u3',
    userName: 'Lisa Processor',
    userRole: 'Processor',
    startDate: '2026-07-14T09:00',
    endDate: '2026-07-17T17:00',
    message: 'Taking a planned personal leave.',
    status: 'Approved',
    coverageIds: ['u2', 'u6'],
  },
  {
    id: 'r5',
    userId: 'u4',
    userName: 'John Officer',
    userRole: 'Loan Officer',
    startDate: '2026-07-15T08:00',
    endDate: '2026-07-16T17:00',
    message: 'Out for a family commitment.',
    status: 'Approved',
    coverageIds: ['u5'],
  },
]
